import React from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Box, Typography, Avatar, IconButton, Button, CircularProgress,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

const DeleteInternalJobDialog = ({ open, job, onClose, onConfirm, deleting }) => {
    if (!job) return null;
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle sx={{ borderBottom: "2px solid #f1f3f5", px: 3, py: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Avatar sx={{ width: 32, height: 32, bgcolor: "#fef2f2" }}>
                        <DeleteIcon sx={{ fontSize: 18, color: "#DC2626" }} />
                    </Avatar>
                    <Typography variant="h6" fontFamily="Montserrat, sans-serif" fontWeight={700} color="#1a1a2e" fontSize={16}>
                        Supprimer le Job Interne
                    </Typography>
                </Box>
                <IconButton onClick={onClose} size="small" disabled={deleting}><CloseIcon /></IconButton>
            </DialogTitle>

            <DialogContent sx={{ pt: "24px !important", px: 3, pb: 2 }}>
                <Box display="flex" alignItems="flex-start" gap={1.5} px={2} py={1.5}
                    sx={{ borderRadius: 2, bgcolor: "#fef2f2", border: "1px solid #fecaca" }}>
                    <DeleteIcon sx={{ color: "#DC2626", fontSize: 20, mt: 0.25, flexShrink: 0 }} />
                    <Box>
                        <Typography fontSize={14} fontWeight={600} color="#991B1B" mb={0.5}>
                            Cette action est irréversible.
                        </Typography>
                        <Typography fontSize={13} color="#7f1d1d">
                            Vous êtes sur le point de supprimer le job{" "}
                            <strong>"{job.job_key}"</strong> (event: <strong>{job.transaction_type}</strong>).
                            Il ne sera plus planifié ni exécuté.
                        </Typography>
                    </Box>
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #e0e0e0", gap: 1 }}>
                <Button onClick={onClose} disabled={deleting} sx={{ color: "text.secondary", textTransform: "none" }}>Annuler</Button>
                <Button variant="contained" onClick={onConfirm} disabled={deleting}
                    startIcon={deleting ? <CircularProgress size={16} color="inherit" /> : <DeleteIcon />}
                    sx={{ bgcolor: "#DC2626", "&:hover": { bgcolor: "#b91c1c" }, textTransform: "none", borderRadius: 2, fontWeight: 600, px: 3 }}>
                    {deleting ? "Suppression..." : "Oui, supprimer"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteInternalJobDialog;
